// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';

import Vant from 'vant'
import {Lazyload,Toast,Uploader} from 'vant'
import store from './store'
import { getToken, setToken, removeToken } from "@/utils/auth";
// import Vconsole from 'vconsole';


// const vConsole = new Vconsole()
// Vue.use(vConsole)
const whiteList = ['/register','login','/wx/error']; 
axios.interceptors.request.use(config => {
 
  // config.method === 'post'
  //     ? config.data = qs.stringify({...config.data})
  //     : config.params = {...config.params};
  console.log(whiteList.indexOf(config.url) )
  if (
    whiteList.indexOf(config.url) !== -1 
  ) {
    // 在免登录白名单，直接进入
    
  }else{
    if(getToken()){

      config.headers.Authorization = getToken();
    }
  }

  console.log(config)
  return config;
}, error => {  //请求错误处理
  
  console.log('请求错误处理')
  console.log(error)
  Toast.fail(error);
  Promise.reject(error)
});
// axios.interceptors.request.use(
//   config => {
//     if (key) { // 判断是否存在token，如果存在的话，则每个http header都加上token
//       key = JSON.parse(localStorage.getItem('key'))
//       config.headers.token = key;
//     } else {}

//     // console.log(config)
//     return config;
//   },
//   err => {

//     return Promise.reject(err);
//   });
axios.interceptors.response.use(function (response) {
  // 处理响应数据
  
  console.log(response)
  return response;
}, function (error) {
  // 处理响应失败
  console.log(error.response)
  if(error.response.data.resp_msg=='尚未登录'){
    removeToken();
    console.log('没有登录')


      return router.push('/login')
  }
  
  Toast.clear();
  return Promise.reject({
    resp_code: 1,
    resp_msg: error.response.data.resp_msg
  });
  // Toast(error.response)

});
import "./permission";
Vue.prototype.$axios = axios
Vue.config.productionTip = false
import Mint from 'mint-ui';
Vue.use(Mint);
//引入UI


import 'vant/lib/index.css'
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Uploader)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js